var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * CreditCardFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCreditCardFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.35714 4C2.73199 4 2.13244 4.24082 1.69039 4.66947C1.24834 5.09812 1 5.67951 1 6.28571L1 7.7181H23V6.28571C23 5.67951 22.7517 5.09812 22.3096 4.66947C21.8676 4.24082 21.268 4 20.6429 4H3.35714ZM1 17.7143V9.62286H23V17.7143C23 18.3205 22.7517 18.9019 22.3096 19.3305C21.8676 19.7592 21.268 20 20.6429 20H3.35714C2.73199 20 2.13244 19.7592 1.69039 19.3305C1.24834 18.9019 1 18.3205 1 17.7143ZM15.9286 14.4762C15.6681 14.4762 15.4183 14.5765 15.2341 14.7551C15.0499 14.9337 14.9464 15.176 14.9464 15.4286C14.9464 15.6812 15.0499 15.9234 15.2341 16.102C15.4183 16.2806 15.6681 16.381 15.9286 16.381H18.2857C18.5462 16.381 18.796 16.2806 18.9802 16.102C19.1644 15.9234 19.2679 15.6812 19.2679 15.4286C19.2679 15.176 19.1644 14.9337 18.9802 14.7551C18.796 14.5765 18.5462 14.4762 18.2857 14.4762H15.9286Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconCreditCardFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCreditCardFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconCreditCardFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-credit-card-filled') === undefined) {
    customElements.define('cat-icon-credit-card-filled', BlocksIconCreditCardFilled);
}
